// extracted by mini-css-extract-plugin
export default {"coverLink":"rO-z","contentBox":"sO-z","zapposPromoContainer":"tO-z","zapposPromoGroupContainer":"uO-z","promos":"vO-z","bottom":"wO-z","top":"xO-z","right":"yO-z","left":"zO-z"};